import { render, staticRenderFns } from "./BrandProfile.vue?vue&type=template&id=5015bbbb"
import script from "./BrandProfile.vue?vue&type=script&lang=js"
export * from "./BrandProfile.vue?vue&type=script&lang=js"
import style0 from "./BrandProfile.vue?vue&type=style&index=0&id=5015bbbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports